export const USER_SETTINGS_TABS_ID = {
	ACCOUNT: 'account',
	TIER: 'tier',
	OFFICE_GROUP: 'office_group',
	COLORS_WEBSITE: 'colors_website',
	COLORS_ITEM: 'colors_item',
    SITE_GROUP: 'sites_group',
	WEB_SUPPLIER_GROUP: 'web_supplier_group',
	// The acriss groups used by One Way (CU-869fkp1t3): moved here from the One Way menu, same gate
	ACRISS_GROUP: 'acriss_group',
	// The user's profile for Iris (CU-869fkmt6r). Not a tab since CU-869fmherf (its own page, /user/iris):
	// kept as the `?tab=` value that redirects there (`@services/tabs.js` irisRedirect)
	IRIS: 'iris',
}